import DefaultApiService from "./default";

const baseBySource = (source) =>
  source === "Management"
    ? "SLN/Management/CustomerPriceOffers"
    : "SLN/SolarentOperator/CustomerPriceOffers";

const CustomerPriceOffersReviewApi = {
  getCustomerPriceOffersByRequest: async (source, requestId) => {
    try {
      const res = await DefaultApiService.getCustomeApi(
        `${baseBySource(source)}/GetCustomerPriceOffersByRequest?requestId=${requestId}`
      );
      if (!res) {
        return { ok: false, message: "پاسخ خالی از سرور", data: [] };
      }
      return {
        ok: res?.isSuccess !== false,
        message: res?.message || "",
        data: res?.data ?? res ?? [],
      };
    } catch (e) {
      return {
        ok: false,
        message:
          e?.response?.data?.message ||
          e?.message ||
          "خطا در دریافت پیشنهاد قیمت مشتری",
        data: [],
      };
    }
  },

  getCustomerPriceOfferDetails: async (source, customerPriceOfferId) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetCustomerPriceOfferDetails?customerPriceOfferId=${customerPriceOfferId}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data,
    };
  },

  createCustomerPriceOffer: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/CreateCustomerPriceOffer`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data,
    };
  },

  recalculateCustomerPriceOffer: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/RecalculateCustomerPriceOffer`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data,
    };
  },

  approveCustomerPriceOffer: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/ApproveCustomerPriceOffer`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data,
    };
  },

  rejectCustomerPriceOffer: async (source, payload) => {
    const res = await DefaultApiService.postApi(
      `${baseBySource(source)}/RejectCustomerPriceOffer`,
      payload
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data,
    };
  },

  getPaymentScheduleDefaults: async (source, requestId, finalPrice) => {
    const priceQuery =
      finalPrice != null && finalPrice !== ""
        ? `&finalPrice=${encodeURIComponent(finalPrice)}`
        : "";
    const res = await DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetPaymentScheduleDefaults?requestId=${requestId}${priceQuery}`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: res?.data,
    };
  },
};

export default CustomerPriceOffersReviewApi;
